import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import CheckBoxCard from '@/components/Form/CheckBoxCard';

// STYLES
import { TitleContainer, Title, ContentContainer } from '../styles';

const Content = ({ t, values, handleChange, handleBlur, onCheckboxChange, isRequired }) => {
  const variants = [
    { text: t('common.genres.action'), value: '12' },
    { text: t('common.genres.cartoon'), value: '18' },
    { text: t('common.genres.comedy'), value: '1' },
    { text: t('common.genres.crime'), value: '17' },
    { text: t('common.genres.drama'), value: '2' },
    { text: t('common.genres.family'), value: '10' },
    { text: t('common.genres.food'), value: '20' },
    { text: t('common.genres.horror'), value: '41' },
    { text: t('common.genres.movies'), value: '51' },
    { text: t('common.genres.news'), value: '8' },
    { text: t('start.content.nonFictionReplace'), value: '27' },
    { text: t('common.genres.reality'), value: '6' },
    { text: t('common.genres.religion'), value: '9' },
    { text: t('common.genres.spanish'), value: '36' },
    { text: t('common.genres.sports'), value: '14' },
    { text: t('common.genres.other'), value: '4' },
  ];

  const handleCheckboxChange = event => {
    onCheckboxChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {t('start.content.title')}
        </Title>
        <Typography variant="subtitle1" align="center">
          {t('start.content.subtitle')}
        </Typography>
      </TitleContainer>
      <ContentContainer container spacing={0}>
        {variants.map(item => (
          <Grid item xs={4} sm={4} md={3} key={item.value}>
            <CheckBoxCard
              name="content"
              value={item.value}
              text={item.text}
              handleChange={handleCheckboxChange}
              handleBlur={handleBlur}
              checkedValue={values.content}
              height={70}
            />
          </Grid>
        ))}
      </ContentContainer>
    </>
  );
};

Content.defaultPros = {
  isRequired: false,
};

Content.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
};

export default withTranslation()(React.memo(Content));
